import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useUser } from "../context/UserContext"

const API = process.env.REACT_APP_API_URL

function CambiarPassword() {
  const { user } = useUser()
  const navigate = useNavigate()

  const [step, setStep] = useState("solicitar")
  const [cuit, setCuit] = useState(user?.cuit || "")
  const [email, setEmail] = useState("")
  const [code, setCode] = useState("")
  const [nuevaPassword, setNuevaPassword] = useState("")
  const [confirmar, setConfirmar] = useState("")
  const [mensaje, setMensaje] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSolicitar = async (e) => {
    e.preventDefault()
    setMensaje(null)
    if (!cuit || !email) {
      setMensaje({ tipo: "error", texto: "Completá todos los campos" })
      return
    }
    setLoading(true)
    try {
      await fetch(`${API}/auth/solicitar-codigo`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cuit, email }),
      })
      setMensaje({ tipo: "ok", texto: "Si los datos son correctos, recibirás un código en tu email en los próximos minutos." })
      setStep("confirmar")
    } catch {
      setMensaje({ tipo: "error", texto: "Error de conexión" })
    } finally {
      setLoading(false)
    }
  }

  const handleConfirmar = async (e) => {
    e.preventDefault()
    setMensaje(null)
    if (!code || !nuevaPassword || !confirmar) {
      setMensaje({ tipo: "error", texto: "Completá todos los campos" })
      return
    }
    if (nuevaPassword !== confirmar) {
      setMensaje({ tipo: "error", texto: "Las contraseñas no coinciden" })
      return
    }
    setLoading(true)
    try {
      const res = await fetch(`${API}/auth/cambiar-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cuit, code, nuevaPassword }),
      })
      const data = await res.json()
      if (!res.ok) {
        setMensaje({ tipo: "error", texto: data.error || "Error al cambiar contraseña" })
        return
      }
      setMensaje({ tipo: "ok", texto: "Contraseña actualizada correctamente. Redirigiendo..." })
      setTimeout(() => navigate("/login"), 2000)
    } catch {
      setMensaje({ tipo: "error", texto: "Error de conexión" })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login column">
      <div className="loginCard column">
        <div className="loginHeader column">
          <div className="loginTitle">CAMBIAR CONTRASEÑA</div>
        </div>

        {step === "solicitar" ? (
          <form onSubmit={handleSolicitar} className="login-form column">
            <label>CUIT (usuario)</label>
            <input
              type="text"
              placeholder="Sin guiones"
              value={cuit}
              onChange={e => setCuit(e.target.value)}
            />
            <label>Email registrado</label>
            <input
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            {mensaje && (
              <div className={mensaje.tipo === "ok" ? "loginOk" : "loginError"}>
                {mensaje.texto}
              </div>
            )}
            <button type="submit" disabled={loading}>
              {loading ? "enviando..." : "enviar código"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleConfirmar} className="login-form column">
            {mensaje && mensaje.tipo === "ok" && (
              <div className="loginOk">{mensaje.texto}</div>
            )}
            <label>Código recibido por email</label>
            <input
              type="text"
              placeholder="6 dígitos"
              value={code}
              maxLength={6}
              onChange={e => setCode(e.target.value)}
            />
            <label>Nueva contraseña</label>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={nuevaPassword}
              onChange={e => setNuevaPassword(e.target.value)}
            />
            <label>Confirmar contraseña</label>
            <input
              type="password"
              placeholder="Repetir contraseña"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
            />
            {mensaje && mensaje.tipo === "error" && (
              <div className="loginError">{mensaje.texto}</div>
            )}
            <button type="submit" disabled={loading}>
              {loading ? "confirmando..." : "confirmar cambio"}
            </button>
            <span className="loginForgot" onClick={() => { setStep("solicitar"); setMensaje(null) }}>
              reenviar código
            </span>
          </form>
        )}

        <Link to="/login" className="loginForgot">volver</Link>
      </div>
    </div>
  )
}

export default CambiarPassword
